import React, { Fragment, useState } from "react";
import "./hero_.css";
import VisibilitySensor from "react-visibility-sensor";
import VideoMontageMobile from "../video_montage_mobile/VideoMontageMobile";
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
const Hero = () => {
  const headings = [
    {
      __html: "<span class='fade-in-text'>Anthem proudly presents</span>",
    },
    {
      __html:
        "<span class='fade-in-text'>Our most advanced and <br /> sophisticated processor to date <br/></span>",
    },
    {
      __html: "<span class='fade-in-text'>Meet AVM 90</span>",
    },
  ];

  const [headingID, setHeadingID] = useState();
  const [opacity, setOpacity] = useState(1);
  const [isVisible, setIsVisible] = useState(true);
  const [height, setHeight] = useState(0);

  React.useEffect(() => {
    function handleScroll() {
      const elementBoundaries = document
        .querySelector("#heading")
        .getBoundingClientRect();

      let percentage = 0;

      if (elementBoundaries.top - 500 < 0) {
        percentage = Math.abs(
          ((elementBoundaries.top - 500) / elementBoundaries.height) * 100
        );

        percentage = percentage > 100 ? 100 : percentage;
      }

      if (percentage < 33 && headingID !== 0) {
        setHeadingID(0);
      } else if (percentage > 33 && percentage < 66 && headingID !== 1) {
        setHeadingID(1);
      } else if (percentage > 66 && headingID !== 2) {
        setHeadingID(2);
      }
    }

    var frameNumber = 0,
      playbackConst = 1000,
      vid = document.getElementById("v0");

    function scrollPlay() {
      var frameNumber = window.pageYOffset / playbackConst;
      vid.currentTime = frameNumber;
      window.requestAnimationFrame(scrollPlay);
    }

    window.requestAnimationFrame(scrollPlay);

    document.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  React.useEffect(() => {
    window.addEventListener("scroll", listenToScroll);
    return () => window.removeEventListener("scroll", listenToScroll);
  }, []);

  const listenToScroll = () => {
    let heightToHideFrom = 20;
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    setHeight(winScroll);

    if (winScroll > heightToHideFrom) {
      isVisible && setIsVisible(false);
    } else {
      setIsVisible(true);
    }
  };

  return (
    <section id="hero" className="bg-black relative">
      <div className="relative hidden lg:block" id="heading">
        {/* <div> */}

        <div className="z-50">
          <div
            // className={`fixed w-3/4 top-1/4 lg:top-[655px] left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50`}
            className={`fixed w-3/4 top-1/4  left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 ${
              isVisible ? "lg:top-[60%]" : "lg:top-2/3"
            }`}
          >
            {!isVisible ? (
              <h1
                // className="text-white font-bold text-3xl md:text-4xl lg:text-6xl text-center pb-56"
                className={`text-white font-bold text-3xl md:text-4xl lg:text-6xl text-center ${
                  isVisible ? "pb-56" : "pb-[14.5rem]"
                }`}
                style={{ opacity: opacity }}
                dangerouslySetInnerHTML={headings[headingID]}
              ></h1>
            ) : null}

            {isVisible && (
              <div className="scroll-down">
                <div className="mouse"></div>
                <p className="scroll-text">Scroll</p>
              </div>
            )}
          </div>
        </div>

        <div className=" z-50  " style={{ height: "1200px" }}>
          <div className="sticky  top-1/2 left-1/2 transform  -translate-y-1/2 z-50">
            <h1 className="text-white font-bold text-3xl md:text-4xl lg:text-6xl text-center"></h1>
          </div>
        </div>
        <div className=" z-50 " style={{ height: "1200px" }}>
          <div className="sticky  top-1/2 left-1/2 transform  -translate-y-1/2 z-50">
            <h1 className="text-white font-bold text-3xl md:text-4xl lg:text-6xl text-center"></h1>
          </div>
        </div>
        <div className=" z-50 " style={{ height: "1600px" }}>
          <div className="sticky  top-1/2 left-1/2 transform  -translate-y-1/2 z-50">
            <h1 className="text-white font-bold text-3xl md:text-4xl lg:text-6xl text-center"></h1>
          </div>
        </div>

        <video
          className={`fixed w-full lg:w-3/4 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 `}
          id="v0"
          tabIndex={0}
          preload="preload"
        >
          <source
            type='video/mp4;codecs="avc1.42E01E, mp4a.40.2"'
            src="https://cdn.pmlsound.com/anthem/avm90/videos/Avm90-first_animation_optimized.mp4"
          ></source>
        </video>
      </div>
      {/* </div> */}
      <div className="lg:hidden bg-black">
        {/* <div className="text-gray-50 px-6 pt-24 ">
          <h1 className="text-white font-bold text-3xl text-center">
            Anthem proudly presents
          </h1>
        </div>
        <img
          src="https://cdn.pmlsound.com/anthem/avm90/images/hero_mobile.png"
          className="m-auto"
        />
        <div className="text-gray-50 px-6 ">
          <h1 className="text-white font-bold text-3xl  text-center mb-16">
            Our most advanced and sophisticated processor to date
          </h1>
        </div> */}
        <VideoMontageMobile />
      </div>
    </section>
  );
};

export default Hero;
